function ShimmerBlock({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <div
      className={`chart-skeleton-shimmer relative overflow-hidden bg-white/5 ${className ?? ""}`}
      style={style}
    />
  );
}

export default function ChartSkeleton({
  hideHeader = false,
  fill = false,
}: {
  hideHeader?: boolean;
  /** Fill a fixed-height chart slot (e.g. cypherpunk deferred charts). */
  fill?: boolean;
} = {}): React.ReactElement {
  const chartAreaClass = fill
    ? "relative flex-1 min-h-0 h-full w-full overflow-hidden"
    : "relative flex-1 min-h-[380px] sm:min-h-[420px] min-[1800px]:min-h-[520px] w-full overflow-hidden";

  const rootClass = fill
    ? "relative w-full h-full flex flex-col min-h-0 overflow-hidden"
    : "relative w-full flex-1 flex flex-col min-h-0 overflow-hidden pt-2";

  return (
    <div className={rootClass}>
      {!hideHeader && (
        <div className="flex justify-between items-center gap-3 mb-3">
          <ShimmerBlock className="h-[13px] w-[140px]" />
          <div className="flex items-center gap-2">
            <ShimmerBlock className="h-[26px] w-[175px]" />
            <ShimmerBlock className="h-[26px] w-[56px]" />
          </div>
        </div>
      )}

      <div className={chartAreaClass}>
        <svg
          viewBox="0 0 460 160"
          preserveAspectRatio="none"
          className="absolute inset-0 h-full w-full"
        >
          {[0, 32, 64, 96, 128, 160].map((y) => (
            <line
              key={y}
              x1="0"
              y1={y}
              x2="400"
              y2={y}
              stroke="rgba(255,255,255,0.05)"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
              shapeRendering="crispEdges"
            />
          ))}
        </svg>

        <div
          className="absolute right-0 top-0 flex h-full flex-col items-start justify-between py-0"
          style={{ width: 55 }}
        >
          {[42, 36, 44, 38, 42, 36].map((w, i) => (
            <ShimmerBlock key={i} className="h-[9px]" style={{ width: w }} />
          ))}
        </div>

        <div className="chart-skeleton-overlay pointer-events-none absolute inset-0 overflow-hidden" />
      </div>

      <div className="mt-1 flex justify-between pr-[55px]">
        {[28, 32, 26, 32, 0].map((w, i) => (
          <ShimmerBlock key={i} className="h-[9px]" style={{ width: w }} />
        ))}
      </div>
    </div>
  );
}
